export const GetCustomerName = async() =>
{

    var result = [];
    const apiUrl = window.BASE_URL + '/api/pdd/HospitalName'
    const response= await fetch(apiUrl)
    result = response.json();
    return result;
}
export const TryPath = (path) => {
    var image = new Image();
    image.src = path;
    if (image.width == 0) {
      return false;
    } else {
      return true;
    }
}
export const ISValidateNationalNumber = async(NationalNumber) =>
{

    var result = [];
    const apiUrl = window.BASE_URL + '/api/pdd/ReservationValidateNationalNumber?NationalNumber='+NationalNumber
    const response= await fetch(apiUrl)
    result = response.json();
    return result;
}